// File Manager mock data
export type FileType = 'folder' | 'document' | 'image' | 'video' | 'audio' | 'spreadsheet' | 'presentation' | 'pdf' | 'archive' | 'code';

export interface FileItem {
  id: string;
  name: string;
  type: FileType;
  size?: number; // in bytes
  mimeType?: string;
  parentId: string | null;
  path: string;
  ownerId: string;
  ownerName: string;
  sharedWith?: string[];
  starred: boolean;
  trashed: boolean;
  createdAt: Date;
  modifiedAt: Date;
  thumbnail?: string;
}

export const mockFiles: FileItem[] = [
  // Root folders
  {
    id: 'folder-1',
    name: 'Documents',
    type: 'folder',
    parentId: null,
    path: '/Documents',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: true,
    trashed: false,
    createdAt: new Date('2023-01-15'),
    modifiedAt: new Date('2024-01-20'),
  },
  {
    id: 'folder-2',
    name: 'Images',
    type: 'folder',
    parentId: null,
    path: '/Images',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2023-02-20'),
    modifiedAt: new Date('2024-01-18'),
  },
  {
    id: 'folder-3',
    name: 'Projects',
    type: 'folder',
    parentId: null,
    path: '/Projects',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: true,
    trashed: false,
    createdAt: new Date('2023-03-10'),
    modifiedAt: new Date('2024-01-21'),
  },
  {
    id: 'folder-4',
    name: 'Shared',
    type: 'folder',
    parentId: null,
    path: '/Shared',
    ownerId: 'u1',
    ownerName: 'John Doe',
    sharedWith: ['u2', 'u3', 'u5'],
    starred: false,
    trashed: false,
    createdAt: new Date('2023-04-05'),
    modifiedAt: new Date('2024-01-19'),
  },
  {
    id: 'folder-5',
    name: 'Archive',
    type: 'folder',
    parentId: null,
    path: '/Archive',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2023-05-12'),
    modifiedAt: new Date('2024-01-10'),
  },

  // Documents folder contents
  {
    id: 'doc-1',
    name: 'Project Proposal.docx',
    type: 'document',
    size: 245760,
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    parentId: 'folder-1',
    path: '/Documents/Project Proposal.docx',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: true,
    trashed: false,
    createdAt: new Date('2024-01-10'),
    modifiedAt: new Date('2024-01-20'),
  },
  {
    id: 'doc-2',
    name: 'Meeting Notes.docx',
    type: 'document',
    size: 128000,
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    parentId: 'folder-1',
    path: '/Documents/Meeting Notes.docx',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2024-01-18'),
    modifiedAt: new Date('2024-01-18'),
  },
  {
    id: 'doc-3',
    name: 'Q4 Report.pdf',
    type: 'pdf',
    size: 3145728,
    mimeType: 'application/pdf',
    parentId: 'folder-1',
    path: '/Documents/Q4 Report.pdf',
    ownerId: 'u1',
    ownerName: 'John Doe',
    sharedWith: ['u2', 'u6'],
    starred: true,
    trashed: false,
    createdAt: new Date('2024-01-05'),
    modifiedAt: new Date('2024-01-15'),
  },
  {
    id: 'sheet-1',
    name: 'Budget 2024.xlsx',
    type: 'spreadsheet',
    size: 512000,
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    parentId: 'folder-1',
    path: '/Documents/Budget 2024.xlsx',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2024-01-02'),
    modifiedAt: new Date('2024-01-19'),
  },
  {
    id: 'pres-1',
    name: 'Team Presentation.pptx',
    type: 'presentation',
    size: 8388608,
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    parentId: 'folder-1',
    path: '/Documents/Team Presentation.pptx',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2024-01-12'),
    modifiedAt: new Date('2024-01-17'),
  },

  // Images folder contents
  {
    id: 'img-1',
    name: 'Product Screenshot.png',
    type: 'image',
    size: 2097152,
    mimeType: 'image/png',
    parentId: 'folder-2',
    path: '/Images/Product Screenshot.png',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2024-01-15'),
    modifiedAt: new Date('2024-01-15'),
    thumbnail: '/thumbnails/screenshot.png',
  },
  {
    id: 'img-2',
    name: 'Team Photo.jpg',
    type: 'image',
    size: 4194304,
    mimeType: 'image/jpeg',
    parentId: 'folder-2',
    path: '/Images/Team Photo.jpg',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: true,
    trashed: false,
    createdAt: new Date('2024-01-08'),
    modifiedAt: new Date('2024-01-08'),
    thumbnail: '/thumbnails/team.jpg',
  },
  {
    id: 'img-3',
    name: 'Logo Design.svg',
    type: 'image',
    size: 51200,
    mimeType: 'image/svg+xml',
    parentId: 'folder-2',
    path: '/Images/Logo Design.svg',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2024-01-10'),
    modifiedAt: new Date('2024-01-18'),
  },
  {
    id: 'img-4',
    name: 'Banner.png',
    type: 'image',
    size: 1572864,
    mimeType: 'image/png',
    parentId: 'folder-2',
    path: '/Images/Banner.png',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2024-01-12'),
    modifiedAt: new Date('2024-01-12'),
    thumbnail: '/thumbnails/banner.png',
  },

  // Projects folder contents
  {
    id: 'folder-proj-1',
    name: 'Website Redesign',
    type: 'folder',
    parentId: 'folder-3',
    path: '/Projects/Website Redesign',
    ownerId: 'u1',
    ownerName: 'John Doe',
    sharedWith: ['u2', 'u3', 'u5'],
    starred: true,
    trashed: false,
    createdAt: new Date('2024-01-01'),
    modifiedAt: new Date('2024-01-21'),
  },
  {
    id: 'folder-proj-2',
    name: 'Mobile App',
    type: 'folder',
    parentId: 'folder-3',
    path: '/Projects/Mobile App',
    ownerId: 'u1',
    ownerName: 'John Doe',
    sharedWith: ['u4', 'u16'],
    starred: false,
    trashed: false,
    createdAt: new Date('2023-11-01'),
    modifiedAt: new Date('2024-01-20'),
  },
  {
    id: 'code-1',
    name: 'app.tsx',
    type: 'code',
    size: 25600,
    mimeType: 'text/typescript',
    parentId: 'folder-proj-1',
    path: '/Projects/Website Redesign/app.tsx',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2024-01-15'),
    modifiedAt: new Date('2024-01-21'),
  },
  {
    id: 'code-2',
    name: 'styles.css',
    type: 'code',
    size: 12800,
    mimeType: 'text/css',
    parentId: 'folder-proj-1',
    path: '/Projects/Website Redesign/styles.css',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: false,
    createdAt: new Date('2024-01-15'),
    modifiedAt: new Date('2024-01-20'),
  },

  // Shared folder contents
  {
    id: 'shared-doc-1',
    name: 'Team Guidelines.pdf',
    type: 'pdf',
    size: 1048576,
    mimeType: 'application/pdf',
    parentId: 'folder-4',
    path: '/Shared/Team Guidelines.pdf',
    ownerId: 'u2',
    ownerName: 'Jane Smith',
    sharedWith: ['u1', 'u3', 'u5'],
    starred: false,
    trashed: false,
    createdAt: new Date('2023-12-01'),
    modifiedAt: new Date('2024-01-10'),
  },
  {
    id: 'shared-sheet-1',
    name: 'Resource Planning.xlsx',
    type: 'spreadsheet',
    size: 768000,
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    parentId: 'folder-4',
    path: '/Shared/Resource Planning.xlsx',
    ownerId: 'u6',
    ownerName: 'Diana Prince',
    sharedWith: ['u1', 'u2'],
    starred: true,
    trashed: false,
    createdAt: new Date('2024-01-05'),
    modifiedAt: new Date('2024-01-19'),
  },

  // Trashed files
  {
    id: 'trash-1',
    name: 'Old Design.psd',
    type: 'image',
    size: 52428800,
    mimeType: 'image/vnd.adobe.photoshop',
    parentId: null,
    path: '/Old Design.psd',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: true,
    createdAt: new Date('2023-06-15'),
    modifiedAt: new Date('2024-01-15'),
  },
  {
    id: 'trash-2',
    name: 'Draft v1.docx',
    type: 'document',
    size: 102400,
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    parentId: null,
    path: '/Draft v1.docx',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: true,
    createdAt: new Date('2023-09-20'),
    modifiedAt: new Date('2024-01-10'),
  },
  {
    id: 'trash-3',
    name: 'Backup.zip',
    type: 'archive',
    size: 104857600,
    mimeType: 'application/zip',
    parentId: null,
    path: '/Backup.zip',
    ownerId: 'u1',
    ownerName: 'John Doe',
    starred: false,
    trashed: true,
    createdAt: new Date('2023-10-01'),
    modifiedAt: new Date('2024-01-08'),
  },
];

// File stats
export const fileStats = {
  totalFiles: 25,
  totalFolders: 7,
  totalSize: 178257920, // ~170MB
  sharedFiles: 6,
  starredFiles: 6,
  trashedFiles: 3,
  recentFiles: 10,
};

// Storage usage
export const storageUsage = {
  used: 178257920,
  total: 10737418240, // 10GB
  byType: [
    { type: 'Documents', size: 4505600, color: 'blue' },
    { type: 'Images', size: 59768832, color: 'green' },
    { type: 'Videos', size: 0, color: 'red' },
    { type: 'Other', size: 113983488, color: 'gray' },
  ],
};

// Helper to format file size
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Get files by parent
export const getFilesByParent = (parentId: string | null, includeTrashed = false) => {
  return mockFiles.filter(f => f.parentId === parentId && (includeTrashed || !f.trashed));
};

// Get starred files
export const getStarredFiles = () => mockFiles.filter(f => f.starred && !f.trashed);

// Get shared files
export const getSharedFiles = () => mockFiles.filter(f => f.sharedWith && f.sharedWith.length > 0 && !f.trashed);

// Get trashed files
export const getTrashedFiles = () => mockFiles.filter(f => f.trashed);

// Get recent files
export const getRecentFiles = (limit = 10) => {
  return mockFiles
    .filter(f => f.type !== 'folder' && !f.trashed)
    .sort((a, b) => b.modifiedAt.getTime() - a.modifiedAt.getTime())
    .slice(0, limit);
};
